export * from './menu-item.model';
export * from './menu-session-state.model';
export * from './menu-config.model';
export * from './menuConfig';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu/models/index.ts